//PaymentSuccess.js

const PaymentSuccess = () => {
  return (
      <h1 className="font-bold text-xl">Your Payment is successful !</h1>
  );
}

export default PaymentSuccess;